module.exports = __webpack_public_path__ + "img/012-resources.8e912c47.svg";